module.exports = __webpack_public_path__ + "img/bp_giftbg_0014.52de06cf.png";